import * as PIXI from "pixi.js";
import Layers from "../../../../src/layers/Layers";
import { RootEventBus, EnumRootEventBus } from "../../../../src/managers/RootEventBus";
import { ASSETS } from "../types/Config";
import { Coord } from "../../../../src/types/Interface";
import generatePoints from "../../../../src/utils/generatePoints";
import getAngleBetweenPoints from "../../../../src/utils/getAngleBtwPoints";
import SwapSprite from "../../../../src/animation/SwapSprite";
import { QuasimodoPartial } from "../types/interface";
import addSprite from "../helpers/addSprite";
import calcDistanceBtwPoints from "../../../../src/utils/calcDistanceBtwPoints";


const _scale = 112 / 604


export default class Quasimodo extends PIXI.Container {
  private Layers = Layers.getInstance();
  private RootEventBus = RootEventBus;
  private head: QuasimodoPartial;
  private foot: QuasimodoPartial[];
  private corkscrew: QuasimodoPartial;
  private pant: PIXI.Graphics;


  constructor(coord: Coord) {
    super();
    Object.assign(this, coord);
    this.add();

    this.addToLayer();
    this.RootEventBus.on(EnumRootEventBus.startIntroAnim, () => this.setVisible(false));
  }
  addToLayer = () => this.Layers.Bottom.addChild(this);
  setVisible(status: boolean) {
    [this.head, this.corkscrew, ...this.foot].forEach(QmdPart => {
      const scale = QmdPart.scaleValue
      if (status) {
        new SwapSprite(QmdPart, scale * .5, scale)
      } else {
        new SwapSprite(QmdPart, scale, scale * .5, () => QmdPart.visible = status)
      }
    });
    if (!status) {
      this.pant.clear();
    }
  }

  add() {
    this.addPant();
    this.addHead();
    this.addFoot();
    this.addCorkscrew();
  }

  addHead = () => {
    this.head = addSprite(ASSETS[0], { width: 133, height: 138, scale: 133 / 489 }, { x: .5, y: 1 });
    this.addChild(this.head);
  }
  addCorkscrew = () => {
    this.corkscrew = addSprite(ASSETS[2], { width: 105, height: 661, scale: .35 }, { x: .5, y: 0 });
    this.Layers.Info.addChild(this.corkscrew);
  }
  addFoot() {
    this.foot = Array(2).fill(null).map((_, fI) => {
      const scale = 112 / 604 * (fI == 0 ? 1 : -1);
      const feet = addSprite(ASSETS[1], { width: 112, height: 77, scale }, { x: .85, y: 0 });
      feet.scale.set(scale, scale);
      this.addChild(feet);
      return feet;
    })
  }
  addPant() {
    this.pant = new PIXI.Graphics()
    this.addChild(this.pant);
  }
  drawPant(sltdTPIndex: number, pIndex: number, radius: number, radians: number[], clockwise: boolean) {
    const points = generatePoints({ x: 0, y: 0 }, radians, radius);

    const rs = clockwise ? [radians[sltdTPIndex], radians[pIndex]] : [radians[pIndex], radians[sltdTPIndex]]
    this.pant
      .clear()
      .moveTo(points[sltdTPIndex].x, points[sltdTPIndex].y)
      .lineTo(points[pIndex].x, points[pIndex].y)
      .arc(0, 0, radius, rs[0], rs[1])
      .fill(0xF4AF74);
  }

  updateCoord(sltdTPIndex: number, radians: number[], radius: number, clockwise: boolean) {
    const prevIndex = sltdTPIndex != 0 ? sltdTPIndex - 1 : radians.length - 1;
    const nextIndex = sltdTPIndex != radians.length - 1 ? sltdTPIndex + 1 : 0;
    const points = generatePoints({ x: 0, y: 0 }, radians, radius + 25);


    const corkPoint = {
      x: this.x + Math.cos(radians[sltdTPIndex]) * (radius - 30),
      y: this.y + Math.sin(radians[sltdTPIndex]) * (radius - 30)
    }

    Object.assign(this.foot[0], points[sltdTPIndex]);
    Object.assign(this.foot[1], points[prevIndex]);
    Object.assign(this.head, points[nextIndex]);
    Object.assign(this.corkscrew, corkPoint);

    const footScale = clockwise ? -_scale : _scale
    this.foot[0].rotation = radians[sltdTPIndex] - Math.PI / 2;
    this.foot[0].scale.set(footScale, Math.abs(footScale));
    this.foot[1].rotation = radians[prevIndex] - Math.PI / 2;
    this.foot[1].scale.set(-footScale, Math.abs(footScale));

    const corkRadian = getAngleBetweenPoints(points[nextIndex], points[sltdTPIndex])
    this.head.rotation = radians[nextIndex] + Math.PI / 2;
    this.corkscrew.rotation = corkRadian + Math.PI / 2;

    const distance = calcDistanceBtwPoints(points[sltdTPIndex], points[nextIndex])
    this.corkscrew.scale.set(this.corkscrew.scaleValue, this.corkscrew.scaleValue * (distance < 365 ? distance / 365 : 1))
    this.drawPant(sltdTPIndex, prevIndex, radius, radians, clockwise);
  }
}